<div [ngClass]="['mp-select', size, customClasses, outlinedColor ?? 'primary', outlinedStyle ?? 'solid']" #selectField
  tabindex="0"
  (click)="openSelectDropdown()"
  (keydown.enter)="openSelectDropdown()"
  [class.outlined]="outlined"
  [class.disabled]="disabled"
  [class.readonly]="isReadOnly"
  [class.opened]="displayDropdown()"
  [class.with-icon]="faIcon">
  @if (faIcon) {
    <i [ngClass]="['mp-select-icon', faIcon, (outlined && outlinedColor) ? outlinedColor : '']"
      [class.without-value]="!hasValue()"
    ></i>
  }
  @if (!displaySelectedValue || !hasValue(); as isEmpty) {
    <span
      class="mp-select-label"
      [class.without-value]="isEmpty">
      {{ label | translate }}
    </span>
  }
  @if (displaySelectedValue) {
    <span class="mp-select-field"
      [class.without-value]="!hasValue()">
      @if (!optionLabelTemplate) {
        <span class="mp-select-value"
          [mpTooltip]="getOverflowTooltip(selectValue)"
          [mpTooltipDisabled]="disabled || !isEllipsisActive()">
          {{ getOptionLabel(selectValue) | translate }}
        </span>
      }
      @if (optionLabelTemplate && !multiple) {
        <span class="mp-select-value">
          <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: selectValue }"></ng-container>
        </span>
      }
      @if (optionLabelTemplate && multiple && Array.isArray(selectValue)) {
        <span class="mp-select-value"
          [mpTooltip]="getOverflowTooltip(selectValue)"
          [mpTooltipDisabled]="disabled || !isEllipsisActive()">
          <div class="custom-multiple-value">
            @for (option of selectValue; track option; let isLast = $last) {
              <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: option }"></ng-container>
              @if (!isLast) {
                <span>,</span>
              }
            }
          </div>
        </span>
      }
    </span>
  }
  @if (!isReadOnly && canResetSelect()) {
    <span class="reset-value" tabindex="0"
      (click)="resetSelectValue($event)"
      (keydown.enter)="resetSelectValue($event)">
      <i class="far fa-times-circle value-remove-icon"></i>
    </span>
  }

  @if (displayDropdown()) {
    <app-mp-select-dropdown
      [anchor]="selectFieldElementRef"
      (keydown)="onDocumentKeydown($event)"
      (dropdownDisplayed)="autoCompleteField?.nativeElement?.focus()">
      @if (autocompleteBehavior || fetchDataBehaviorAsync) {
        <input class="select-autocomplete" type="text" #autoCompleteField
          [(ngModel)]="autocompleteValue"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="autocompleteSearchLabel | translate"
          (ngModelChange)="autocompleteValueChanged($event)"/>
      }
      <div class="select-option-wrapper"
        infiniteScroll
        [alwaysCallback]="true"
        [scrollWindow]="false"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="fetchAsyncData(false)">
        @for (option of availableOptions; track option; let index = $index) {
          <div class="select-option"
            [class.highlighted]="index === highlightedOptionIndex"
            [class.selected]="isSelectedOption(option) && displaySelectedValue"
            (click)="onValueChanged(option)">
            @if (optionLabelTemplate) {
              @if (multiple) {
                <mp-checkbox [label]="getOptionLabel(option)" [checked]="isChecked(option)" [size]="size">
                  <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: option }"/>
                </mp-checkbox>
              }
              @if (!multiple) {
                <span>
                  <ng-container *ngTemplateOutlet="optionLabelTemplate; context: { option: option }"/>
                </span>
              }
            }
            @if (!optionLabelTemplate) {
              @if (multiple) {
                <mp-checkbox
                  [size]="size"
                  [label]="getOptionLabel(option)"
                  [checked]="isChecked(option)">
                </mp-checkbox>
              }
              @if (!multiple) {
                <span>{{ getOptionLabel(option) | translate }}</span>
              }
            }
          </div>
        }
        @if (fetchingData) {
          <div class="select-option-loader">
            <i class="fas fa-spin fa-circle-notch"></i>
          </div>
        }
      </div>
    </app-mp-select-dropdown>
  }
</div>
